import {
    BlocklistedOrganizationDto,
    CompanyBlocklistDto,
    PreviewProspectingDtos,
    ProspectDto,
    ProspectComposedDto,
    ProspectSearchFiltersDto,
    ProspectQueryResultDto,
} from '@zaplify/prospects';
import { BaseSdk } from '../../base.sdk';

export class ProspectsSdk extends BaseSdk {
    async getProspectByIdsBatch(prospectIds: string[]) {
        return await this.post<any>({ path: `${this.prospectsPath}/get-batch`, payload: prospectIds });
    }

    /**
     * @deprecated
     * Should ONLY be used in admin-purposes
     */
    async forceReleaseProspect(prospectIds: string[]) {
        return await this.post<void>({
            path: `${this.prospectsPath}/release`,
            payload: { ids: prospectIds, force: true },
        });
    }

    async textSearch(query: string) {
        return this.get<PreviewProspectingDtos.ResponsePerCompany>(`${this.prospectsPath}/search?query=${query}`);
    }

    async getGeneratedFilters() {
        return this.get<ProspectSearchFiltersDto>(`${this.sourcesPath}/prospect-search/generated-filters`);
    }

    async getBlacklist(userOrganizationId: string) {
        return this.get<CompanyBlocklistDto>(`${this.prospectsPath}/${userOrganizationId}/blocklist`);
    }

    async getAvatarUrls(prospectIds: string[]) {
        return this.get<Record<string, string>>(
            `${this.prospectsPath}/linkedin-profile-images?prospectIds=${JSON.stringify(prospectIds)}`,
        );
    }

    async replaceBlacklist(newBlocklist: CompanyBlocklistDto) {
        return this.put<{
            blocklist: CompanyBlocklistDto;
            added: number;
            skipped: number;
        }>(`${this.prospectsPath}/${newBlocklist.organizationId}/blocklist`, newBlocklist);
    }

    async deleteCompanyFromBlocklist(organizationId: string, organizationName: BlocklistedOrganizationDto) {
        return this.delete<CompanyBlocklistDto>(`${this.prospectsPath}/${organizationId}/blocklist`, organizationName);
    }

    async deleteAllCompaniesFromBlocklist(organizationId: string) {
        return this.delete<CompanyBlocklistDto>(`${this.prospectsPath}/${organizationId}/blocklist/all`);
    }

    getProspect = async (prospectId: string) => {
        return await this.get<ProspectDto>(`${this.prospectsPath}/${prospectId}`);
    };

    getProspectComposed = async (prospectId: string) => {
        return await this.get<ProspectComposedDto>(`${this.prospectsPath}/${prospectId}/complete`);
    };

    async searchProspectIds(body: {
        prospectIds: string[];
        organizationId: string;
        regex?: string[];
        sort?: any;
        page?: number;
        perPage?: number;
    }) {
        return this.post<ProspectQueryResultDto>({ path: `${this.prospectsPath}/search/prospectIds`, payload: body });
    }
}
